<template>
  <div class="section">
    <div class="container ist-container">
      <FieldCheckbox
        id="date"
        v-model="showDate"
        label="show date"
        :options="showDateOptions"
      />
      <FieldCheckbox
        id="validate-date"
        v-model="validateDate"
        label="validate date"
        :options="validateDateOptions"
      />
      <div v-if="showDate.value.yes">
        <FieldDate
          v-model="dateModel"
          label="FieldDate"
          :validate="validateDate.value.enabled"
        />
      </div>
      <hr>
      <p>
        Model of show:
        <pre>{{ showDate }}</pre>
      </p>
      <p>
        Model of validate:
        <pre>{{ validateDate }}</pre>
      </p>
      <p>
        Model of FieldDate :
        <pre>{{ dateModel }}</pre>
      </p>
      <hr>
      <ReportModal
        :is-loading="isPdfLoading"
        @generateReport="downloadPdf"
      />
    </div>
  </div>
</template>

<script>
// import Field from '../components/Simulation/Field.vue';
import FieldCheckbox from '../components/Simulation/FieldCheckbox.vue';
import FieldDate from '../components/Simulation/FieldDate.vue';
// import FieldRadio from '../components/Simulation/FieldRadio.vue';
// import FieldSelect from '../components/Simulation/FieldSelect.vue';
import ReportModal from '../components/Results/ReportModal.vue';

export default {
  components: {
    // Field,
    FieldCheckbox,
    FieldDate,
    // FieldRadio,
    // FieldSelect,
    ReportModal,
  },
  data() {
    return {
      showDateOptions: [
        { value: 'yes', label: 'yes' },
      ],
      showDate: { value: { yes: true } },
      validateDateOptions: [
        { value: 'enabled', label: 'enabled' },
      ],
      validateDate: { value: { enabled: false } },
      dateModel: { value: '', ok: false },
      // report
      isPdfLoading: false,
    };
  },
  methods: {
    async downloadPdf(userContent) {
      this.isPdfLoading = true;
      // user content
      const userContentTokens = [];
      Object.keys(userContent).forEach((key) => {
        userContentTokens.push(
          { key, type: 'string', data: userContent[key] },
        );
      });
      // request PDF
      const response = await this.$api.call('POST', 'api/pdf-export-func', {
        header: {
          Accept: 'application/json',
        },
        responseType: 'blob',
        data: {
          template: 'example-full',
          tokens: [
            ...userContentTokens,
            { key: 'title', type: 'string', data: 'XXX' },
            { key: 'subtitle', type: 'string', data: `${this.$product.name} - Report` },
            { key: 'date', type: 'string', data: this.$filters.formatDate(new Date()) },
            { key: 'placeholder', type: 'string', data: 'Hello World' },
          ],
        },
      });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response.data]));
      link.setAttribute('download', 'IST_Report.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      this.isPdfLoading = false;
    },
  },
};
</script>

<style scoped>
</style>
